export default ({ return_method: returnMethod, display_method: displayMethod, carrier }) => {
  const methodKey = displayMethod || returnMethod;
  return carrier ? `${methodKey}_${carrier}` : methodKey;
};
